// extracted by mini-css-extract-plugin
export default {"donutChart":"Char_donutChart__s8hlN"};